import { Box, Checkbox, Stack, Tooltip, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export const canSaveForFollowingVisits = (visit) => (visit?.visit_number ?? -1) >= 0;

const OVERWRITE_INFO =
  "When checked, saving also writes this configuration to every following visit, overwriting what is there, and keeps doing so on every later save of this visit.";

const SaveForFollowingVisitsCheckbox = ({ label, checked, onChange, disabled = false }) => (
  <Box>
    <Stack direction="row" alignItems="center" spacing={1}>
      <Checkbox checked={checked} onChange={onChange} disabled={disabled} />
      <Typography variant="body2">{label}</Typography>
      <Tooltip title={OVERWRITE_INFO} arrow>
        <InfoOutlinedIcon fontSize="small" color="action" />
      </Tooltip>
    </Stack>
    {checked && (
      <Stack direction="row" alignItems="flex-start" spacing={0.5} sx={{ pl: 6, pb: 0.5 }}>
        <Typography variant="caption" color="text.secondary">
          Later visits will be overwritten when you save.
        </Typography>
      </Stack>
    )}
  </Box>
);

export default SaveForFollowingVisitsCheckbox;
